import { Button, Group } from '@mantine/core';
import { i18n } from '@lingui/core';
import { FC } from 'react';
import { openDeleteConfirmModal } from '../../Atoms/DeleteConfirmModal';
import GrayBox from '../../Atoms/GrayBox';
import DocumentBubbleMenu from '../../Organismns/tiptap/toolbars/BubbleMenu';
import { RichInputWithoutMentions } from '../../Organismns/tiptap/TiptapEditorInput';
import { useEventScope } from '../../Service/hooks/useEventScope';
import { LogDto } from '../../Types/LogT';

interface Props {
  note: LogDto;
  updateHandler: (id: string, patch: Partial<LogDto>) => Promise<boolean>;
  deleteHandler: (id: string) => Promise<boolean>;
}

const NotePreviewItem: FC<Props> = ({ note, updateHandler, deleteHandler }) => {
  const { id, entityType, value } = note;
  const { isEventScope } = useEventScope();
  const showBadge = isEventScope && note.entityType === 'contacts';

  const delNote = () => {
    openDeleteConfirmModal({
      title: i18n._('event.notes.delete.confirm.head'),
      description: i18n._('event.notes.delete.confirm'),
      onConfirm: () => deleteHandler(id),
    });
  };

  return (
    <GrayBox p="xs">
      <RichInputWithoutMentions
        includeListExtentions
        value={value}
        patchField={(html) => updateHandler(id, { value: html })}
        styles={{ minHeight: 100 }}
        menu={<DocumentBubbleMenu includeListOpts />}
      />
      <Group mt={5} position={showBadge ? 'center' : 'center'}>
        <Button size="xs" color="red" variant="subtle" onClick={delNote}>
          {`${entityType === 'events' ? 'Event' : 'Kontakt'}-Notiz löschen`}
        </Button>
      </Group>
    </GrayBox>
  );
};

export default NotePreviewItem;
